export type ButtonVariant = 'primary' | 'outline' | 'dark' | 'light';
export type ButtonSize = 'sm' | 'md' | 'lg';

const base =
  'inline-flex items-center justify-center gap-2 whitespace-nowrap font-display font-bold uppercase tracking-[0.08em] transition-[background-color,border-color,color,transform] duration-150 ease-out active:scale-[0.98] disabled:cursor-not-allowed disabled:opacity-60';

const variants: Record<ButtonVariant, string> = {
  primary: 'bg-brand-action text-white hover:bg-brand-action-hover',
  outline: 'border border-white/70 text-white hover:border-white hover:bg-white hover:text-charcoal',
  dark: 'bg-charcoal text-white hover:bg-charcoal-700',
  light: 'bg-white text-charcoal hover:bg-steel-200',
};

const sizes: Record<ButtonSize, string> = {
  sm: 'h-10 px-4 text-[14px]',
  md: 'h-12 px-6 text-[15px]',
  lg: 'h-14 px-8 text-base',
};

export function buttonClass(variant: ButtonVariant = 'primary', size: ButtonSize = 'md', extra = '') {
  return `${base} ${variants[variant]} ${sizes[size]} ${extra}`.trim();
}
